<template>
  <div class="main-chat">
    <beautiful-chat
      :showConversation="showConversation"
      :multipleChatsEnabled="true"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :chatList="chatList"
      :close="closeChat"
      :colors="colors"
      :isOpen="isChatOpen"
      :messageList="messageList"
      :messageStyling="messageStyling"
      :newMessagesCount="newMessagesCount"
      :onMessageWasSent="sendMessage"
      :open="openChat"
      :participants="participants"
      :showCloseButton="true"
      :showLauncher="showLauncher"
      :showEmoji="false"
      :showFile="false"
      :showTypingIndicator="showTypingIndicator"
      :showEdition="false"
      :showDeletion="false"
      :showLike="false"
      :showConfirmationDeletion="false"
      :confirmationDeletionMessage="'Are you sure? '"
      :titleImageUrl="titleImageUrl"
      :chatListTitle="chatListTitle"
      :title="title"
      :disableUserListToggle="false"
      @onType="handleOnType"
      @edit="editMessage"
      @remove="removeMessage"
      @changeCurrentChat="handleChangeCurrentChat"
    >
      <template v-slot:text-message-toolbox="scopedProps">
        <button
          v-if="!scopedProps.me && scopedProps.message.type === 'text'"
          @click.prevent="like(scopedProps.message.id)"
        >
          👍
        </button>
      </template>
      <template v-slot:text-message-body="scopedProps">
        <p
          class="sc-message--text-content"
          v-html="scopedProps.messageText"
        ></p>
        <p
          v-if="scopedProps.message.data.meta"
          class="sc-message--meta"
          :style="{ color: scopedProps.messageColors.color }"
        >
          {{ scopedProps.message.data.meta }}
        </p>
        <p
          v-if="scopedProps.message.isEdited || scopedProps.message.liked"
          class="sc-message--edited"
        >
          <template v-if="scopedProps.message.isEdited">✎</template>
          <template v-if="scopedProps.message.liked">👍</template>
        </p>
      </template>
      <template v-slot:system-message-body="{ message }">
        [System]: {{ message.text }}
      </template>
    </beautiful-chat>
    <div class="order-filter" v-if="isChatOpen && activeOrder">
      <div class="inside-test">
        <button
          class="btn btn-round"
          @click="isOrderContext = true"
          v-bind:class="isOrderContext && 'btn-primary'"
        >
          Pedido #{{ activeOrder.code }}
        </button>
        <button
          class="btn btn-round"
          @click="isOrderContext = false"
          v-bind:class="!isOrderContext && 'btn-primary'"
        >
          Todos
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import * as sdk from "matrix-js-sdk";
import DmMap from "./dmMap";
import availableColors from "./colors";
import uniqBy from "lodash/uniqBy";
import sortBy from "lodash/sortBy";

const DEFAULT_MATRIX_SERVER = "https://matrix.fractopia.org/";

export default {
  name: "biochat",
  data() {
    return {
      client: null,
      DmMap: null,
      currentChatID: null,
      room: null,
      timeline: null,
      userList: [],
      showLauncher: false,
      showConversation: null,
      isOrderContext: false,
      participants: [],
      chatList: [],
      messageList: [],
      titleImageUrl: null,
      title: "",
      newMessagesCount: 0,
      isChatOpen: false,

      colors: null,
      availableColors,
      chosenColor: null,
      alwaysScrollToBottom: true,
      messageStyling: true,
      userIsTyping: true,
      showTypingIndicator: "",
    };
  },
  created() {
    this.setColor("green");

    if (this.isSeller) {
      this.loadList("users", {
        params: {
          populate: "supplier",
        },
      })
        .then((users) => {
          if (users) {
            this.userList = users;
          }

          if (!this.client) {
            this.createClient();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      if (!this.client) {
        this.createClient();
      }
    }
  },
  methods: {
    init() {
      this.DmMap = new DmMap(this.client);
      this.DmMap.start();
      this.getChatList();
      if (this.currentChatID) {
        this.getRoomMembers();
      }
      this.client.setDisplayName(this.currentUser.name);
      this.client.on("Room.timeline", (event, room, toStartOfTimeline) => {
        if (event.getType() !== ("m.room.message" || "m.room.redaction")) {
          return;
        }

        if (event.getType() === "m.room.create") {
          this.getChatList();
        }

        if (
          event.getRoomId() === this.timeline.getRoomId() &&
          event.getType() === ("m.room.message" || "m.room.redaction")
        ) {
          this.getMessages();
        }
      });
    },
    async createClient() {
      if (
        !this.currentUser ||
        !this.currentUser._id ||
        !this.currentUser.matrixLogin
      ) {
        return;
      }
      try {
        var opts = {};
        try {
          let store = new sdk.IndexedDBStore({
            indexedDB:
              window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB,
            dbName: this.currentUser.matrixLogin,
          });
          await store.startup();
          opts = { store };
        } catch (e) {
          console.log("IndexDB error:", e);
        }

        this.client = await sdk.createClient({
          baseUrl: DEFAULT_MATRIX_SERVER,
          ...opts,
        });

        await this.client.loginWithPassword(
          this.currentUser.matrixLogin,
          "tCDMiELuphq5Dr"
        );

        this.client;
      } catch (e) {
        console.log("matrix login error", e);
        this.client = null;
      }

      if (!this.client) {
        return;
      }

      await this.client.startClient({ initialSyncLimit: 10 });
      this.client.once("sync", (state, prevState, res) => {
        if (state === "PREPARED") {
          console.log("Prepared");
          this.showLauncher = true;
          this.init();
        } else {
          console.log(state);
        }
      });
    },
    logoutChat() {
      this.client.logout();
      this.client.stopClient();
      this.client = null;
      this.showLauncher = false;
      this.isChatOpen = false;
    },
    async getMessages() {
      var room = this.client.getRoom(this.currentChatID);

      if (!room) return;

      this.timeline = room.getLiveTimeline();
      this.messageList = this.timeline
        .getEvents()
        .reduce((messages, event, index) => {
          var content = event.getContent();
          var sender = event.getSender();
          var user = this.client.getUser(sender);
          var author =
            user.userId === this.client.getUserId() ? "me" : user.userId;
          // var a = timelineEvent.
          if (!content.body) {
            return messages;
          }
          return [
            ...messages,
            {
              type: "text",
              author,
              id: event.getId(),
              data: { text: content.body },
              read: true,
            },
          ];
        }, []);
    },

    async handleChangeCurrentChat(newCurrentChatID) {
      // this.showTypingIndicator = ''
      var room;
      if (newCurrentChatID.length > 0 && newCurrentChatID[0] === "@") {
        var dms = this.DmMap.getDMRoomsForUserId(newCurrentChatID);
        var dmChat = dms.length > 0 ? dms[0] : null;
        if (!dmChat) {
          room = await this.client.createRoom({
            invite: [newCurrentChatID],
            visibility: "private",
            is_direct: true,
          });

          if (room) {
            this.DmMap.setDMRoom(room.room_id, newCurrentChatID);
            this.currentChatID = room.room_id;
          } else {
            return;
          }
        } else {
          room = this.client.getRoom(dmChat);
          this.isChatOpen = true;

          this.currentChatID = dmChat;
        }
      } else {
        room = this.client.getRoom(newCurrentChatID);
        this.isChatOpen = true;

        this.currentChatID = newCurrentChatID;
      }
      this.title = this.calculateRoomName(room);
      this.getMessages();
      this.getChatList();
      this.getRoomMembers();

      // this.titleImageUrl = room.imageUrl;
    },
    async getOrderChatList() {
      var members = this.getUsersFromOrder(this.activeOrder);
      return members.reduce((list, member) => {
        if (member.id === this.client.getUserId()) {
          return list;
        }
        return [
          ...list,
          {
            id: member.id,
            name: member.name,
            imageUrl:
              "https://t4.ftcdn.net/jpg/01/18/03/35/160_F_118033506_uMrhnrjBWBxVE9sYGTgBht8S5liVnIeY.jpg",
            unreadCount: 0,
          },
        ];
      }, []);
    },
    getFullChatList() {
      var roomList = this.client.getRooms().reduce((list, room) => {
        var name = this.calculateRoomName(room);
        var members = room.currentState.getMembers();

        if (members.length != 2 || room.name.includes("Pedido")) {
          return list;
        }

        var userEvent = room.currentState
          .getStateEvents("m.room.member", this.client.getUserId())
          .getContent();

        if (userEvent.membership === "invite") {
          this.client.joinRoom(room.roomId);
          this.DmMap.setDMRoom(room.roomId, this.client.getUserId());
        }

        var lastModifiedTime = room.currentState.getLastModifiedTime();

        return [
          ...list,
          {
            id: room.roomId,
            name: name,
            imageUrl:
              "https://t4.ftcdn.net/jpg/01/18/03/35/160_F_118033506_uMrhnrjBWBxVE9sYGTgBht8S5liVnIeY.jpg",
            lastModifiedTime,
            unreadCount: 0,
          },
        ];
      }, []);

      return sortBy(roomList, "lastModifiedTime").reverse();
    },
    async getChatList() {
      this.chatList =
        this.isOrderContext && this.activeOrder
          ? await this.getOrderChatList()
          : this.getFullChatList();
    },
    sendMessage(text) {
      if (text.data.text.length > 0) {
        // this.newMessagesCount = this.isChatOpen
        //   ? this.newMessagesCount
        //   : this.newMessagesCount + 1;
        this.client.sendTextMessage(this.currentChatID, text.data.text);
        this.getMessages();
      }
    },
    onMessageWasSent(message) {
      this.messageList = [
        ...this.messageList,
        Object.assign({}, message, { id: Math.random() }),
      ];
    },

    editMessage(message) {
      const m = this.messageList.find((m) => m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
    async removeMessage(message) {
      this.messageList = this.messageList.filter(({ id }) => id !== message.id);
      await this.client.redactEvent(this.currentChatID, message.id);
    },
    getUsersFromOrder(order) {
      var users = [];
      order.items.forEach((orderItem) => {
        const { offer } = orderItem;
        if (!offer || !offer.supplier) {
          return;
        }

        var supplierUsers = offer.supplier.users;
        supplierUsers.forEach((user) => {
          if (user.matrixLogin) {
            users.push({
              id: user.matrixLogin,
              name: `${user.name} (${offer.supplier.name})`, // TO-DO:
            });
          }
        });
      });
      var client = order.client;
      if (order.client.matrixLogin) {
        users.push({
          id: client.matrixLogin,
          name: client.name,
        });
      }

      if (order.orderIssuer && order.orderIssuer.matrixLogin) {
        users.push({
          id: order.orderIssuer.matrixLogin,
          name: order.orderIssuer.name,
        });
      }

      return uniqBy(users, "id");
    },
    getUsername(biobaId) {
      var user = this.findBiobaUserFromId(biobaId);
      return user ? user.matrixLogin : null;
    },
    async getRoomMembers() {
      this.participants = await this.fetchRoomMembers(this.currentChatID);
    },
    async fetchRoomMembers(roomId) {
      var room = this.client.getRoom(roomId);

      var members = await Promise.all(
        room.currentState
          .getMembers()
          .map(async ({ name: matrixName, userId }) => {
            // if (!user) {
            //   user = await this.client.getUser(userId);
            // }
            // var avatar =
            //   user && user.avatarUrl
            //     ? this.client.mxcUrlToHttp(
            //         user.avatarUrl,
            //         200,
            //         200,
            //         "scale",
            //         true
            //       )
            //     : "https://t4.ftcdn.net/jpg/01/18/03/35/160_F_118033506_uMrhnrjBWBxVE9sYGTgBht8S5liVnIeY.jpg";
            var user = this.findBiobaUserFromMxId(userId);
            var name = (user && user.name) || matrixName;

            if (userId === this.client.getUserId()) {
              name += " (Eu)";
            }
            return {
              id: userId,
              name,
              imageUrl:
                "https://t4.ftcdn.net/jpg/01/18/03/35/160_F_118033506_uMrhnrjBWBxVE9sYGTgBht8S5liVnIeY.jpg",
            };
          })
      );

      return members;
    },
    calculateRoomName(room) {
      if (!room.currentState) {
        room = this.client.getRoom(room.room_id);
      }
      var members = room.currentState.getMembers();
      var name = room.name;
      if (members.length === 2) {
        var otherUser = members.find(
          (member) => member.userId !== this.client.getUserId()
        );
        var biobaUser = this.findBiobaUserFromMxId(otherUser.userId);
        if (biobaUser) {
          name =
            biobaUser.supplier && biobaUser.supplier.name
              ? `${biobaUser.name} (${biobaUser.supplier.name})`
              : biobaUser.name;
        }
        return name;
      }
    },
    findBiobaUserFromId(id) {
      return this.userList.find((user) => user._id === id);
    },
    findBiobaUserFromMxId(userId) {
      var user = this.userList.find((user) => user.matrixLogin === userId);

      return user;
    },
    openChat() {
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      this.isChatOpen = false;
    },
    setColor(color) {
      this.colors = this.availableColors[color];
      this.chosenColor = color;
    },

    messageStylingToggled(e) {
      this.messageStyling = e.target.checked;
    },
    handleOnType() {
      this.$root.$emit("onType");
      this.userIsTyping = true;
    },

    async createLocalStorage(deviceId, sessionId) {
      let localStorage = global.localStorage;
      if (typeof localStorage === "undefined" || localStorage === null) {
        const deviceDesc = `matrix-chat-${deviceId}-${sessionId}`;
        const localStoragePath = path.resolve(
          path.join(os.homedir(), ".local-storage", deviceDesc)
        );
        localStorage = new LocalStorage(localStoragePath);
      }
      return localStorage;
    },
  },

  computed: {
    chatListTitle() {
      return this.activeOrder && this.isOrderContext
        ? `Pedido # ${this.activeOrder.code}`
        : "Conversas";
    },
    activeOrder() {
      return this.$store.state.activeOrder;
    },
    newChatRequest() {
      return this.$store.state.newChatRequest;
    },
    linkColor() {
      return this.chosenColor === "dark"
        ? this.colors.sentMessage.text
        : this.colors.launcher.bg;
    },
    backgroundColor() {
      return this.chosenColor === "dark" ? this.colors.messageList.bg : "#fff";
    },
    authStatus() {
      return this.currentUser;
    },
  },
  watch: {
    authStatus(newUser, oldUser) {
      if (oldUser && !newUser) {
        this.logoutChat();
      }
      if (!oldUser && newUser) {
        this.createClient();
      }
    },
    async newChatRequest(newRequestId, oldRequest) {
      if (newRequestId && !oldRequest) {
        await this.handleChangeCurrentChat(this.getUsername(newRequestId));
        this.isChatOpen = true;
        this.showConversation = newRequestId;

        this.$store.dispatch("startChatWith", null);
      }
    },
    activeOrder(newOrder, oldOrder) {
      if (newOrder !== null && oldOrder === null) {
        this.isOrderContext = true;
      }

      if (newOrder === null && oldOrder !== null) {
        this.isOrderContext = false;
      }
    },
    isOrderContext(newStatus, oldstatus) {
      this.getChatList();
    },
  },
};
</script>

<style>
.main-chat {
  position: "absolute";
  z-index: 99999999 !important;
}
.inside-test {
  display: flex;
  justify-content: flex-start;
}
.order-filter {
  width: 60px;
  height: 60px;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  right: 300px;
  bottom: 25px;
  border-radius: 50%;
  box-shadow: none;
  transition: box-shadow 0.2s ease-in-out;
  cursor: pointer;
}
</style>
